// extracted by mini-css-extract-plugin
module.exports = {"subfooter":"style_subfooter__hNn1B","container":"style_container__YS4hz","text":"style_text___LGOy","links":"style_links__m_1tU"};